import { FC } from "react";
import WhatsappIcon from "@ht/shared/fonts/deos-pis/whatsapp";
import TeamsIcon from "@ht/shared/fonts/deos-pis/teams";
import ArsiIcon from "@ht/shared/fonts/deos-pis/arsi";
import FacebookIcon from "@ht/shared/fonts/deos-pis/facebook";
import InstagramIcon from "@ht/shared/fonts/deos-pis/instagram";
import TwitterIcon from "@ht/shared/fonts/deos-pis/twitter";

const ChannelIcon: FC<{ channel: string; className?: string }> = ({
    channel,
    className,
}) => {
    let result;
    if (channel == "WHATSAPP") result = <WhatsappIcon />;
    else if (channel == "INSTAGRAM") result = <InstagramIcon />;
    else if (channel == "FACEBOOK") result = <FacebookIcon />;
    else if (channel == "TWITTER") result = <TwitterIcon />;
    else if (channel == "TEAMS") result = <TeamsIcon />;
    else result = <ArsiIcon />;
    return <div className={className}>{result}</div>;
};

export default ChannelIcon;
